<template>
  <div>
    <b-row>
      <b-colxx xl="12" lg="12" class="mb-4">
        <b-card title="Rendez-vous d'aujourd'hui">
          <vuetable
            :tableHeight="'100%'"
            ref="vuetable"
            :api-mode="false"
            :fields="rdvs.fields"
            :data="listRdv"
            @vuetable:row-clicked="rowClicked"
            :noDataTemplate="'Aucun rendez-vous trouvé.'"
            @vuetable:pagination-data="onPaginationData"
          ></vuetable>
          <!-- <vuetable-pagination-bootstrap
            ref="pagination"
            @vuetable-pagination:change-page="onChangePage"
          ></vuetable-pagination-bootstrap> -->
        </b-card>
      </b-colxx>
      <b-colxx xl="12" lg="12" class="mb-4">
        <b-row class="row">
          <b-colxx md="12" lg="6" xl="6" class="mb-4">
            <radial-progress-card
              :title="'Status de Paiement'"
              :percent="parseFloat(percentPayment.toFixed(2))"
            />
          </b-colxx>
          <b-colxx md="12" lg="6" xl="6" class="mb-4">
            <radial-progress-card
              title="Progrès d'accomplissment"
              :percent="parseFloat(percentDone.toFixed(2))"
            />
          </b-colxx>

          <b-colxx md="12" lg="6" xl="6" class="mb-4">
            <!-- v-if="todayRdvs && todayRdvs.length" -->
            <gradient-with-radial-progress-card
              icon="iconsminds-check"
              :title="`Rendez-vous Complet`"
              detail="Nombre des Rendez-vous completé Aujourd'hui ."
              :percent="
                todayRdvs.length && totalDone ? totalDone / todayRdvs.length : 0
              "
              :progressText="totalDone ? totalDone + '/' + todayRdvs.length : '0'"
            />
          </b-colxx>
          <b-colxx md="12" lg="6" xl="6" class="mb-4">
            <gradient-with-radial-progress-card
              icon="iconsminds-add-user"
              :title="`Nouveaux Patients`"
              detail="Nombre des patients ajoutés Aujourd'hui ."
              :percent="
                listPatients.length
                  ? (totalAddedUser * 100) / listPatients.length
                  : 0
              "
              :progressText="totalAddedUser ? `${totalAddedUser}/${listPatients.length}` : '0'"
            />
          </b-colxx>
        </b-row>
      </b-colxx>
    </b-row>
  </div>
</template>
<script>
import moment from "moment";

import Vuetable from "vuetable-2/src/components/Vuetable";
import VuetablePaginationBootstrap from "@/components/Common/VuetablePaginationBootstrap";

import GradientWithRadialProgressCard from "@/components/Cards/GradientWithRadialProgressCard";

import RadialProgressCard from "@/components/Cards/RadialProgressCard";
import { apiUrl } from "@/constants/config";

export default {
  components: {
    Vuetable,
    VuetablePaginationBootstrap,
    RadialProgressCard,
    GradientWithRadialProgressCard,
  },
  data() {
    return {
      rdvs: {
        fields: [
          {
            name: "id",
            title: "#",
            titleClass: "",
            dataClass: "list-item-heading",
          },
          {
            name: "name",
            title: "Patient",
            titleClass: "",
            dataClass: "list-item-heading",
          },
          {
            name: "heure",
            title: "Heure",
            titleClass: "",
            dataClass: "text-small",
          },
          {
            name: "operation",
            title: "Operation",
            titleClass: "",
            dataClass: "text-small",
          },
          {
            name: "status",
            title: "Status",
            titleClass: "",
            dataClass: "text-small",
          },
        ],
      },
      listRdv: [],
      todayRdvs: [],
      allRdvs: [],
      totalDone: 0,
      totalAddedUser: 0,
      percentDone: 0,
      percentPayment: 0,
      listPatients: [],
    };
  },
  mounted() {
    this.fetchData();
    this.fetchPatients();
    this.fetchCompletionAndPayment();
  },
  methods: {
    rowClicked(data) {
      console.log("row clicked", data);
      this.$router.push({ name: "rdv", params: { id: data.operationId } });
    },
    async fetchPatients() {
      this.totalAddedUser = 0;
      let endpoint = apiUrl + "/patients";
      this.sendRequest("get", endpoint)
        .then((res) => {
          // console.log("reees",res)
          this.listPatients = res.data;
          for (let i = 0; i < this.listPatients.length; i++) {
            let current = this.listPatients[i];
            let date = moment(new Date()).utc().format("YYYY-MM-DD HH:mm");
            let currentDate = moment(current.created_at);
            let dt = currentDate.diff(date, "days");

            if (dt == 0) {
              this.totalAddedUser++;
            }
            // console.log("hellooo iam dt",dt)
          }
        })
        .catch((err) => {
          console.log("iam the error", err);
        });
    },
    async fetchData() {
      let endpoint = apiUrl + "/stats/dashboard/today";
      let dt = { date: new Date() };
      try {
        let totalDone = 0;
        let rdvs = await this.sendRequest("post", endpoint, dt);
        console.log("the data is", rdvs);
        this.todayRdvs = rdvs.data;
        for (let i = 0; i < this.todayRdvs.length; i++) {
          let rdv = this.todayRdvs[i];
          this.listRdv.push({
            id:i+1,
            name: rdv.patient.name,
            operationId: rdv.operationId,
            heure: rdv.heure,
            operation: rdv.operation.description,
            status: rdv.isconfirmed ? "Fini" : "En attente",
          });
          if (rdv.isconfirmed) {
            this.totalDone++;
          }
        }
      } catch (err) {
        console.log("err", err);
      }
    },
    async fetchCompletionAndPayment() {
      let endpoint = apiUrl + "/stats/dashboard/all";
      try {
        let completedRdv = 0;
        let totalToPay = 0;
        let totalPayed = 0;
        let rdvs = await this.sendRequest("post", endpoint);
        console.log("the all data is", rdvs);
        this.allRdvs = rdvs.data;
        for (let i = 0; i < this.allRdvs.length; i++) {
          let rdv = this.allRdvs[i];
          totalToPay = totalToPay + parseFloat(rdv.operation.prixtotale);
          totalPayed = totalPayed + parseFloat(rdv.price_gived);
          // this.listRdv.push({name:rdv.patient.name,heure:rdv.heure,operation:rdv.operation.description,status:rdv.isconfirmed?"Fini":"En attente"})
          if (rdv.isconfirmed) {
            completedRdv++;
          }
        }
        this.percentDone =
          completedRdv && this.allRdvs.length
            ? (completedRdv * 100) / this.allRdvs.length
            : 0;
        this.percentPayment =
          totalToPay && totalPayed ? (totalPayed * 100) / totalToPay : 0;
      } catch (err) {
        console.log("err", err);
      }
    },

    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
  },
};
</script>
<style lang="scss">
.progress-banner {
  background: #317ffe;
  border-radius: 5px;
}
</style>